import type { Slide } from '@segmently/schema-models/v2';

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

function isNumericKey(key: string): boolean {
  return /^\d+$/.test(key);
}

/**
 * Runtime guard for legacy/corrupted carousel data where array-index dot-path
 * writes persisted `items` as a numeric-keyed object instead of an array.
 */
export function normalizeSlideItems(items: unknown): Slide[] {
  if (Array.isArray(items)) {
    return items.filter(Boolean) as Slide[];
  }

  if (!isRecord(items)) {
    return [];
  }

  return Object.entries(items)
    .filter(([key, value]) => isNumericKey(key) && isRecord(value))
    .sort(([left], [right]) => Number(left) - Number(right))
    .map(([, value]) => value as Slide);
}
